import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { FileIcon } from "@/components/files/FileIcon";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function DocPicker({ open, onOpenChange, selected, onChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [sel, setSel] = useState(selected);

  useEffect(() => { if (open) setSel(selected); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.get("/search", { params: { q } }).then((r) => setResults(r.data.files.slice(0, 50))), 250);
    return () => clearTimeout(t);
  }, [q, open]);

  const toggle = (f) => setSel((s) => (s.some((x) => x.id === f.id) ? s.filter((x) => x.id !== f.id) : [...s, { id: f.id, name: f.name }]));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="doc-picker-dialog">
        <DialogHeader><DialogTitle>Joindre des documents à la question</DialogTitle></DialogHeader>
        <Input autoFocus placeholder="Rechercher un document…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="doc-picker-search" />
        <div className="max-h-80 overflow-auto border rounded-md divide-y">
          {results.map((f) => {
            const on = sel.some((x) => x.id === f.id);
            return (
              <button key={f.id} onClick={() => toggle(f)} className={`w-full flex items-center gap-3 px-3 py-2 text-left ${on ? "bg-blue-50" : "hover:bg-slate-50"}`} data-testid={`doc-picker-item-${f.id}`}>
                <FileIcon file={f} size="sm" /><span className="flex-1 text-sm truncate">{f.name}</span>{on && <Check className="h-4 w-4 text-[#1E3A8A]" />}
              </button>
            );
          })}
          {results.length === 0 && <p className="text-sm text-slate-500 p-3">Aucun document</p>}
        </div>
        <DialogFooter>
          <span className="text-xs text-slate-500 mr-auto self-center">{sel.length} sélectionné(s)</span>
          <Button onClick={() => { onChange(sel); onOpenChange(false); }} data-testid="doc-picker-confirm">Valider</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
